"use strict";
import React from "react";
import ReactDOM from "react-dom";
import style from './Loader.scss';



	class Loader extends React.Component {
		constructor(props) {
			super(props);
		}

		render() {
			return (
				<div id="loading-overlay" className="site-loader">
					<div className="load-grid">
						<div className="load load1"></div>
						<div className="load load2"></div>
						<div className="load load3"></div>
						<div className="load load4"></div>
						<div className="load load5"></div>
						<div className="load load6"></div>
						<div className="load load7"></div>
						<div className="load load8"></div>
						<div className="load load9"></div>
					</div>
					<span className="load-text">Loading</span>
				</div>
				);
		}
	}


export default Loader;